export default {
  enteringpayments: {
    title: "Ввод платежей"
  }
};
